/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Deactivated_DescInputs */



/**
* | output |
* | --- |
* | "Access was switched off. Their sessions were ended and any chat in progress was stopped; their spaces, data and connected integrations are preserved." |
*
* @param {Audit_Details_Member_Deactivated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_deactivated_desc = /** @type {((inputs?: Audit_Details_Member_Deactivated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Deactivated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Zugang wurde abgeschaltet. Die Sitzungen wurden beendet und laufende Chats gestoppt; Spaces, Daten und verbundene Integrationen bleiben erhalten.")
	return /** @type {LocalizedString} */ ("Access was switched off. Their sessions were ended and any chat in progress was stopped; their spaces, data and connected integrations are preserved.")
});